import { __ } from '../helpers/i18n';
export const validator = {
    enteredPassword: '',
    required: (value) => {
        return (value) ? '' : __('Pole nie może byc puste');
    },
    min: (length) => (value) => {
        if (!value)
            value = '';
        return (value.length >= length) ? '' : __(`Minimalna liczba znaków: ${length}`);
    },
    max: (length) => (value) => {
        if (!value)
            value = '';
        return (value.length <= length) ? '' : __(`Maksymalna liczba znaków: ${length}`);
    },
    between: (min, max) => (value) => {
        if (!value)
            value = '';
        return (value.length < min || value.length > max) ? __(`Wymagane od ${min} do ${max} znaków`) : '';
    },
    post_code: (value, country, postCodeRegex, postCodeExample, postCodeRequired) => {
        if (!value)
            value = '';
        let message = postCodeExample || '';
        if (!postCodeRequired)
            postCodeRegex = '';
        return value.match(postCodeRegex) ? '' : __('Wprowadź kod pocztowy w wymaganym formacie ' + message);
    },
    phone: (value, country) => {
        if (!value)
            return '';
        if (country === 'PL') {
            const regk = /^(([0]{2}|\+)\d{2}[- ]?)?(\d{3}[- ]?\d{3}[- ]?\d{3})$/; // komórkowe
            const regs = /^(([0]{2}|\+)\d{2}[- ]?)?((\(\d{2}\)|\d{2})[- ]?)(\d{3}[- ]?\d{2}[- ]?\d{2}|\d{2}[- ]?\d{2}[- ]?\d{3})$/; // stacjonarne
            return (regk.test(value) || regs.test(value)) ? '' : __('Niepoprawny nr. telefonu');
        }
        else {
            const reg = /\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/; // Pozostałe państwa
            return (reg.test(value)) ? '' : __('Niepoprawny nr. telefonu (dodaj na początek kod wybranego kraju, np. "+1")');
        }
    },
    email: (value) => {
        const re = /\S+@\S+\.\S+/;
        return (re.test(value)) ? '' : __('Niepoprawny adres email');
    },
    nip: (value) => {
        const nipWithoutDashes = value ? value.replace(/-/g, '') : '';
        const reg = /^[0-9]{10}$/;
        if (reg.test(nipWithoutDashes) == false) {
            return __('Niepoprawny NIP');
        }
        else {
            const reg = /^\d{3}-\d{2}-\d{2}-\d{3}$/;
            const reg2 = /^\d{3}-\d{3}-\d{2}-\d{2}$/;
            const reg3 = /^\d{10}$/;
            if (!reg.test(value) && !reg2.test(value) && !reg3.test(value)) {
                return __('Niepoprawny NIP');
            }
            const digits = ('' + nipWithoutDashes).split('');
            const checksum = (6 * parseInt(digits[0]) + 5 * parseInt(digits[1]) + 7 * parseInt(digits[2]) + 2 * parseInt(digits[3]) + 3 * parseInt(digits[4]) + 4 * parseInt(digits[5]) + 5 * parseInt(digits[6]) + 6 * parseInt(digits[7]) + 7 * parseInt(digits[8])) % 11;
            return (parseInt(digits[9]) == checksum) ? '' : __('Niepoprawny NIP');
        }
    },
    regon: (value) => {
        const reg = /^[0-9]{9}$/;
        return (reg.test(value)) ? '' : __('Niepoprawny numer REGON');
    },
    digits_only: (value) => {
        const reg = /^\d+$/;
        return reg.test(value) ? __('Pole nie może zawierać samych cyfr') : '';
    },
    flat_number: (value) => {
        const reg = /^[0-9A-Za-z/]*$/;
        return reg.test(value) ? '' : __('Niepoprawny numer mieszkania');
    },
    letters_only: (value) => {
        const reg = /^[-\s\p{L}]+$/u;
        return !reg.test(value) ? __('Pole może zawierać tylko litery, spacje i znak "-"') : '';
    },
    no_special_characters: (value) => {
        const reg = /^[/,\sA-Za-z0-9]+$/;
        return !reg.test(value) ? __('Pole nie może zawierać znaków specjalnych') : '';
    },
    dash_only: (value) => {
        const reg = /^[-\s0-9\p{L}]+$/u;
        return !reg.test(value) ? __('Pole może zawierać litery, cyfry, spacje i znak "-"') : '';
    },
    password: (value) => {
        validator.enteredPassword = value;
        const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@$!%*?&])[A-Za-z\d#@$!%*?&]{8,}$/;
        return !reg.test(value) ? __('Wymagane conajmniej 8 znaków, 1 wielka litera, mała litera, cyfra i znak specjalny') : '';
    },
    compare_passwords: (passwordConfirmation) => {
        return (validator.enteredPassword !== passwordConfirmation)
            ? __('Potwierdzenie pola hasło nie zgadza się')
            : '';
    }
};
